import {useState , createContext, useContext} from 'react'

const AuthContext = createContext(null)
 export const AuthProvider = ({ children})=>{
  const [user,setUser]= useState(localStorage.getItem("email"))

//   const login = (user)=>{
//       setUser(user)
//   }
const login = ()=>{
    setUser(user)
}

  const logout = ()=>{
      setUser(null)
  }

  return(
      <AuthContext.Provider value={{user,login,logout}}>
          {children}
      </AuthContext.Provider>
  ) 
 }

 export const useAuth =()=>{
     return useContext(AuthContext)
 }